import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import SorensonLogo from '../../utils/assets/icons/logo.svg';
import ReadyImage from '../../utils/assets/images/illustration-ready.svg';
import SuccessImage from '../../utils/assets/images/illustration-success.svg';
import WelcomeImage from '../../utils/assets/images/illustration-welcome.svg';
import ImageType from 'utils/constants/imageType';
import PillType from 'utils/constants/pillType';
import Pill from '../pill/pill.component';

interface IPageHeader {
  title?: boolean;
  imageOption: ImageType;
  pill?: PillType;
  text: string;
}

const PageHeader: FC<IPageHeader> = ({ title, imageOption, pill, text }) => {
  const imageOptions = {
    ready: ReadyImage,
    success: SuccessImage,
    welcome: WelcomeImage,
  };

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gap: '16px',
          width: '300px',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        {title && (
          <Box sx={{ marginBottom: '10px' }}>
            <img src={SorensonLogo} width='184px' />
          </Box>
        )}
        <Box>
          <img src={imageOptions[imageOption]} width='160px' />
        </Box>
        {pill && (
          <Box
            sx={{
              display: 'grid',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Pill type={pill} />
          </Box>
        )}
        <Typography
          variant='h4'
          sx={{
            fontSize: '30px',
            fontWeight: '600',
          }}
        >
          {text}
        </Typography>
      </Box>
    </>
  );
};

export default PageHeader;
